<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>查询条件</span>
      </div>
        <el-form :inline="true" :model="conditions" class="flex justify-start">
          <el-form-item>
            <el-form-item  >
              <el-select v-model="conditions.feeTypeCd" placeholder="请选择费用大类" style="width:100%">
                <el-option v-for="item in feeTypes" :key="item.feeTypeCd" :label="item.typeName"
                  :value="item.feeTypeCd" />
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item  >
              <el-input v-model="conditions.feeName" placeholder="请输入费用名称" />
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item  >
              <el-select v-model="conditions.isDefault" placeholder="请选择是否默认费用" style="width:100%">
                <el-option v-for="item in isDefaults" :key="item.statusCd" :label="item.name" :value="item.statusCd" />
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-button type="primary" @click="_queryHousekeepingFeeConfigMethod">
                <i class="el-icon-search"></i>查询
              </el-button>
              <el-button @click="_resetHousekeepingFeeConfigMethod">
                <i class="el-icon-refresh"></i>重置
              </el-button>
            </el-form-item>
          </el-form-item>
        </el-form>
    </el-card>

    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>费用标准</span>
        <div style="float: right;">
          <el-button type="primary" size="small" @click="_openAddHousekeepingFeeConfigModal">
            <i class="el-icon-plus"></i>添加
          </el-button>
          <el-button v-if="configId != ''" type="primary" size="small" @click="_openListHousekeepingFeeConfigModal">
            <i class="el-icon-back"></i>返回
          </el-button>
        </div>
      </div>
      <el-table :data="housekeepingFeeConfigs" border style="width: 100%">
        <el-table-column prop="feeName" label="费用名称" align="center" />
        <el-table-column prop="feeBigTypeName" label="费用大类" align="center" />
        <el-table-column prop="computingFormula" label="计算公式" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.computingFormula == '1001'">面积*单价</span>
            <span v-else-if="scope.row.computingFormula == '2002'">固定费用</span>
            <span v-else-if="scope.row.computingFormula == '3003'">费用面议</span>
          </template>
        </el-table-column>
        <el-table-column prop="feePrice" label="单价" align="center" />
        <el-table-column prop="startTime" label="开始时间" align="center" />
        <el-table-column prop="endTime" label="结束时间" align="center" />
        <el-table-column prop="isDefault" label="默认费用" align="center">
          <template slot-scope="scope">
            {{ scope.row.isDefault == 'F' ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="_openEditHousekeepingFeeConfigModel(scope.row)">
              修改
            </el-button>
            <el-button type="text" size="small" @click="_openDeleteHousekeepingFeeConfigModel(scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="total" />
    </el-card>

    <add-housekeeping-fee-config ref="addHousekeepingFeeConfig" @refresh="_listHousekeepingFeeConfigs" />
    <edit-housekeeping-fee-config ref="editHousekeepingFeeConfig" @refresh="_listHousekeepingFeeConfigs" />
    <delete-housekeeping-fee-config ref="deleteHousekeepingFeeConfig" @refresh="_listHousekeepingFeeConfigs" />
  </div>
</template>

<script>
import { queryHousekeepingFeeConfig, queryHousekeepingFeeType } from '@/api/housekeeping/housekeepingFeeConfigApi'
import { getDict } from '@/api/shop/shopApi'
import AddHousekeepingFeeConfig from '@/components/housekeeping/addHousekeepingFeeConfig'
import EditHousekeepingFeeConfig from '@/components/housekeeping/editHousekeepingFeeConfig'
import DeleteHousekeepingFeeConfig from '@/components/housekeeping/deleteHousekeepingFeeConfig'

export default {
  name: 'HousekeepingFeeConfigManage',
  components: {
    AddHousekeepingFeeConfig,
    EditHousekeepingFeeConfig,
    DeleteHousekeepingFeeConfig
  },
  data() {
    return {
      housekeepingFeeConfigs: [],
      feeTypes: [],
      isDefaults: [],
      conditions: {
        feeName: '',
        isDefault: '',
        feeTypeCd: '',
        startTime: '',
        endTime: '',
        shopId: ''
      },
      configId: '',
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  created() {
    this.configId = this.$route.query.configId || ''
    this.conditions.configId = this.configId
    console.log(this.conditions.configId)
    this._listHousekeepingFeeConfigs()
    this._listHousekeepingFeeTypes()
    this._getDictData()
  },
  methods: {
    async _listHousekeepingFeeConfigs() {
      try {
        const params = {
          ...this.conditions,
          page: this.currentPage,
          row: this.pageSize
        }
        const res = await queryHousekeepingFeeConfig(params)
        this.housekeepingFeeConfigs = res.data
        this.total = res.total
      } catch (error) {
        console.error('获取费用标准列表失败:', error)
      }
    },
    async _listHousekeepingFeeTypes() {
      try {
        const params = {
          page: 1,
          row: 50,
          shopId: this.conditions.shopId
        }
        const res = await queryHousekeepingFeeType(params)
        this.feeTypes = res.data
      } catch (error) {
        console.error('获取费用类型失败:', error)
      }
    },
    async _getDictData() {
      try {
        const {data:isDefaults} = await getDict('housekeeping_fee_config', 'is_default')
        this.isDefaults = isDefaults
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    _queryHousekeepingFeeConfigMethod() {
      this.currentPage = 1
      this._listHousekeepingFeeConfigs()
    },
    _resetHousekeepingFeeConfigMethod() {
      this.conditions = {
        feeName: '',
        isDefault: '',
        feeTypeCd: '',
        startTime: '',
        endTime: '',
        shopId: this.conditions.shopId
      }
      this._listHousekeepingFeeConfigs()
    },
    _openAddHousekeepingFeeConfigModal() {
      this.$refs.addHousekeepingFeeConfig.open()
    },
    _openEditHousekeepingFeeConfigModel(row) {
      this.$refs.editHousekeepingFeeConfig.open(row)
    },
    _openDeleteHousekeepingFeeConfigModel(row) {
      this.$refs.deleteHousekeepingFeeConfig.open(row)
    },
    _openListHousekeepingFeeConfigModal() {
      this.$router.push('/pages/housekeeping/housekeepingResourceManage')
    },
    handleSizeChange(val) {
      this.pageSize = val
      this._listHousekeepingFeeConfigs()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._listHousekeepingFeeConfigs()
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
</style>